import React from 'react';
import './pictures-wall.scss';
import { Upload, Icon, Modal } from 'antd';
import { API } from '../../../../utils/static-data';
import { getAuthHeader } from '../../../../utils/utils';

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class PicturesWall extends React.Component {
    state = {
        previewVisible: false,
        previewImage: '',
        fileList: []
    };

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
        });
    };

    handleChange = ({ fileList }) => {
        this.setState({ fileList });
        console.log(fileList);
    };

    render() {
        const { previewVisible, previewImage, fileList } = this.state;
        const uploadButton = (
            <div className="upload-button">
                <Icon type="plus" />
                <div className="ant-upload-text">Subir foto</div>
            </div>
        );
        return (
            <div>
                <div className="clearfix">
                    <Upload
                        action={`${API}/upload/attachment`}
                        headers={getAuthHeader()}
                        listType="picture-card"
                        fileList={fileList}
                        onPreview={this.handlePreview}
                        onChange={this.handleChange}
                        className="upload"
                    >
                        {fileList.length >= 8 ? null : uploadButton}
                    </Upload>
                </div>
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
            </div>
        );
    }
}

export default PicturesWall;